import * as actionType from "../constants";
import * as commonData from "../Common";

export const deleteboard = (input) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${api}board-update`, {
      method: "post",
      body: JSON.stringify(input),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.DELETE_BOARD,
        payload: {
          message: rdata.message,
          status: rdata.status,
          board: true,
          data: rdata.data,
          code: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};
